module.exports = __webpack_public_path__ + "img/11n.e5357091.jpeg";